import { render, staticRenderFns } from "./QueryClaimHeaders.vue?vue&type=template&id=5d42446a&"
import script from "./QueryClaimHeaders.vue?vue&type=script&lang=js&"
export * from "./QueryClaimHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports